import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import CustomSelect from '../../../../../../components/CustomSelect';
import { useDispatch, useSelector } from 'react-redux';
import {
    getSlackDrivers,
    allSlackDrivers,
} from '../../../../../../redux/slices/settingsSlice';
import {
    getClient,
    oneClient,
    updateClientSlackChannels,
} from '../../../../../../redux/slices/clientsSlice';
import { Col, Row } from 'antd';
import { Close } from '../../../../../../components/Svg/Svg';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function SlackTypePage() {
    const dispatch = useDispatch();
    const params = useParams();
    const slackDrivers = useSelector(allSlackDrivers);
    const client = useSelector(oneClient);

    const [data, setData] = useState([]);
    const [selectOptions, setSelectOptions] = useState([]);

    useEffect(() => {
        dispatch(getSlackDrivers());
    }, [dispatch]);

    useEffect(() => {
        const selectOptions = slackDrivers?.reduce((acc, el) => {
            if (!client?.slack_driver_id?.includes(el.id)) {
                acc.push({
                    id: el.id,
                    value: el.channel_name.toLowerCase(),
                    label: el.channel_name,
                });
            }
            return acc;
        }, []);
        const activeSlackChannels = slackDrivers?.reduce((acc, el) => {
            if (client?.slack_driver_id?.includes(el.id)) {
                acc.push({
                    id: el.id,
                    name: el.channel_name,
                });
            }
            return acc;
        }, []);

        setData(activeSlackChannels);
        setSelectOptions(selectOptions);
    }, [slackDrivers, client]);

    const onSelectChange = (option) => {
        const selectedOptionId = option.id;
        const newArr = selectOptions.filter((el) => el.id !== selectedOptionId);

        setSelectOptions(newArr);
        setData([...data, { id: option.id, name: option.label }]);
    };

    const onRemoveChannelTag = (option) => {
        const newData = data.filter((el) => el.id !== option.id);
        const newSelectedOpts = [
            ...selectOptions,
            {
                id: option.id,
                value: option.name.toLowerCase(),
                label: option.name,
            },
        ];
        const sortedOptions = [...newSelectedOpts].sort((a, b) => a.id - b.id);

        setSelectOptions(sortedOptions);
        setData(newData);
    };

    const onSubmit = async () => {
        const slackChannelsIds = data.map((el) => el.id);
        try {
            await dispatch(
                updateClientSlackChannels({
                    id: params.id,
                    body: { slack_driver_id: slackChannelsIds },
                }),
            ).unwrap();
            dispatch(getClient(params.id));
            toast.success('Changes saved successfully');
        } catch (error) {
            toast.error(error.errors);
        }
    };

    return (
        <>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - Notifications - Slack`}</title>
            </Helmet>
            <Row>
                <Col span={10}>
                    <div className="form__item-wrapper">
                        <CustomSelect
                            labelText="Channels"
                            name="slack_driver"
                            onChange={onSelectChange}
                            options={selectOptions}
                            placeholder="Select channels"
                        />
                    </div>
                </Col>
            </Row>
            {data.length > 0 && (
                <div className="slack-type__tags-wrapper">
                    <div className="slack-type__counter-wrapper">
                        <span className="slack-type__channels-counter">
                            {data.length}
                        </span>
                        <span className="slack-type__counter-text">
                            channels selected
                        </span>
                    </div>
                    <ul className="slack-type__tags-list">
                        {data.map((el) => (
                            <li
                                key={el.id}
                                onClick={() => onRemoveChannelTag(el)}
                            >
                                <span className="slack-type__tags-name">
                                    {el.name}
                                </span>
                                <span>
                                    <Close />
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
            <div className="form__footer">
                <button
                    className="modal__button modal__button-accept"
                    type="button"
                    onClick={onSubmit}
                >
                    Save
                </button>
            </div>
        </>
    );
}
